import { CitiesResponse, NearestCityResponse } from './models';
import { createMutation, createQuery } from '../../libs';
import { long_term_cashing } from '@/constants/cashing';

const url = 'cities';

export const useGetCities = createQuery<CitiesResponse>(
  {
    method: 'get',
    url,
  },
  {
    staleTime: long_term_cashing,
  }
);

export const useGetNearestCity = createMutation<NearestCityResponse>({
  method: 'get',
  url: `${url}/cordinates`,
});
